var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordMobilePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 52.5V42.5V42.525M25 50L35 45M25 45L35 50M12.5 42.5V52.5M7.5 50L17.5 45M7.5 45L17.5 50M47.5 42.5V52.5M42.5 50L52.5 45M42.5 45L52.5 50M17.5 35V15C17.5 13.6739 18.0268 12.4021 18.9645 11.4645C19.9021 10.5268 21.1739 10 22.5 10H37.5C38.8261 10 40.0979 10.5268 41.0355 11.4645C41.9732 12.4021 42.5 13.6739 42.5 15V35M27.5 12.5H32.5",
    stroke: "#DE1F4C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordMobilePhone);
export default __webpack_public_path__ + "static/media/password-mobile-phone.ec6cfd5996f8797dc2b1ef8acffcc51f.svg";
export { ForwardRef as ReactComponent };